var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0.833252C4.93766 0.833252 0.833496 4.93742 0.833496 9.99992C0.833496 15.0624 4.93766 19.1666 10.0002 19.1666C15.0627 19.1666 19.1668 15.0624 19.1668 9.99992C19.1668 4.93742 15.0627 0.833252 10.0002 0.833252ZM13.9735 8.44992C14.0467 8.36629 14.1024 8.26887 14.1373 8.16339C14.1723 8.05792 14.1858 7.94651 14.1771 7.83574C14.1683 7.72496 14.1375 7.61705 14.0865 7.51836C14.0354 7.41966 13.9651 7.33217 13.8798 7.26104C13.7944 7.1899 13.6957 7.13655 13.5894 7.10414C13.4831 7.07172 13.3714 7.06089 13.2609 7.07227C13.1504 7.08366 13.0432 7.11704 12.9458 7.17045C12.8483 7.22385 12.7626 7.29621 12.6935 7.38325L9.11016 11.6824L7.256 9.82742C7.09883 9.67562 6.88833 9.59162 6.66983 9.59352C6.45133 9.59542 6.24232 9.68306 6.08781 9.83757C5.93331 9.99208 5.84567 10.2011 5.84377 10.4196C5.84187 10.6381 5.92586 10.8486 6.07766 11.0058L8.57766 13.5058C8.65954 13.5876 8.75757 13.6515 8.86551 13.6933C8.97344 13.7351 9.08891 13.754 9.20455 13.7488C9.3202 13.7435 9.43348 13.7142 9.53717 13.6628C9.64087 13.6113 9.7327 13.5388 9.80683 13.4499L13.9735 8.44992Z",
    fill: "#1A9D86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDefault);
export default __webpack_public_path__ + "static/media/check-default.c24868ab.svg";
export { ForwardRef as ReactComponent };